import { render, staticRenderFns } from "./FetchSubscriptions.vue?vue&type=template&id=1a797e35"
import script from "./FetchSubscriptions.vue?vue&type=script&lang=js"
export * from "./FetchSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports